import LicenseTypeForm from "./LicenseTypeForm";

const AddLicenseTypeForm = ({ isLoading, onSubmit, onCloseClicked }) => {
  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:min-w-[600px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Add license type</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <LicenseTypeForm isLoading={isLoading} onSubmit={onSubmit} />
    </div>
  )
}

export default AddLicenseTypeForm;
